import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      loginData.resetPurchaseData()
    }
  }, [navigate])
  return (
    <>
      <Header title="登録完了しました" />
      <main>
        <section className="mx-4 my-5">
          <p>
            指定されたAUBEクエストIDにAUBEクエストディールが配布されました。
            <br />
            ゲーム内マイページをご確認下さい。
            <br />
            また、契約書面をお申込時の指定先メールアドレスに交付しています。内容をご確認いただき大切に保管して下さい。
          </p>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" href="/myPage">
              マイページへ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
